'use client'

import React, { createContext, useContext, useMemo, useState } from 'react'
import { UpgradeBanner } from '@components/UpgradeBanner/UpgradeBanner'
import styled, { css } from 'styled-components'
import { PaidFeatureType } from '@interfaces/common'

const UpgradeBannerContext = createContext<(feature: PaidFeatureType | null) => void>(
  _ => {},
)

const blurCSS = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(230, 244, 255, 0.6);
  filter: blur(3px);
  z-index: 1000;
  pointer-events: none;
`

const Blur = styled.div<{ isActive: boolean }>`
  ${({ isActive }) => isActive && blurCSS};
`

export const UpgradeBannerProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeBannerFeature, showUpgradeBanner] = useState<PaidFeatureType | null>(null)

  return (
    <UpgradeBannerContext.Provider value={showUpgradeBanner}>
      {activeBannerFeature && (
        <UpgradeBanner
          feature={activeBannerFeature}
          onClose={() => showUpgradeBanner(null)}
        />
      )}
      <Blur isActive={!!activeBannerFeature}>{children}</Blur>
    </UpgradeBannerContext.Provider>
  )
}

export const useShowUpgradeBanner = () => {
  return useContext(UpgradeBannerContext)
}
